import { pathOr } from 'ramda';

import { IState } from '../../../store';

export const selectAgentReviews = (state: IState) => state.offerData.agentReviews;
export const selectCompanyFoundationTime = (state: IState) =>
  pathOr(null, ['offerData', 'company', 'yearFoundation'], state);
export const selectDeveloper = (state: IState) => state.offerData.newObject && state.offerData.newObject.developer;
export const selectOffer = (state: IState) => state.offerData.offer;
